<div class="modal fade show" tabindex="-1"  *ngIf="message && message?.type=='confirm'" role="dialog" style="display:block!important" >
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ 'Confirmación' | translate }}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="message.noFn()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" *ngIf="message?.type == 'confirm'" >
        <p>{{message.text}}</p>
      </div>
      <div class="modal-footer" *ngIf="!message.edit && !message.inactive">
        <button type="button" class="btn btn-primary"  (click)="message.yesFn()">{{ 'CONFIRMAR' | translate }}</button>
        <button type="button" class="btn btn-danger" (click)="message.noFn()">{{ 'CANCELAR' | translate }}</button>
      </div>
      <div class="modal-footer" *ngIf="message.edit && !message.inactive">
        <button type="button" class="btn btn-primary"  (click)="message.yesFn()">{{ 'SI' | translate }}</button>
        <button type="button" class="btn btn-danger" (click)="message.noFn()">{{ 'NO' | translate }}</button>
      </div>
      <div class="modal-footer" *ngIf="message.inactive">
        <button type="button" class="btn btn-primary"  (click)="message.yesFn()">{{ 'INACTIVAR' | translate }}</button>
        <button type="button" class="btn btn-danger" (click)="message.noFn()">{{ 'CANCELAR' | translate }}</button>
      </div>
    </div>
  </div>
</div>


<div class="modal fade show modal-dialog-delete" tabindex="-1"  *ngIf="message && message?.type=='delete'" role="dialog" style="display:block!important" >
  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-body" >
        <h4 class="text-center font-size-24">{{message.text}}</h4>
        <p class="text-center mb-5">{{ 'No podrás recuperarlo y tendrás que crearlo desde cero' | translate }}</p>
        <button type="button" class="btn btn-primary btn-no d-block mb-2"  (click)="message.noFn()">{{ 'No, no quiero eliminarlo' | translate }}</button>
        <button type="button" class="btn btn-link btn-yes m-auto d-block" (click)="message.yesFn()">{{ 'Sí, quiero eliminarlo' | translate }}</button>
      </div>

    </div>
  </div>
</div>

<div class="modal fade show modal-dialog-delete" tabindex="-1"  *ngIf="message && message?.type=='delete_moment'" role="dialog" style="display:block!important" >
  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-body" >
        <h4 class="text-center font-size-24">{{message.text}}</h4>
        <p class="text-center mb-5">{{ 'La eliminación no puede revertirse, tendrás que recrear el momento y se podrían generar inconsistencias en la información, haremos lo posible para evitarlo' | translate }}</p>
        <button type="button" class="btn btn-primary btn-no d-block mb-2"  (click)="message.noFn()">{{ 'No, no eliminar' | translate }}</button>
        <button type="button" class="btn btn-link btn-yes m-auto d-block" (click)="message.yesFn()">{{ 'Sí, deseo eliminar el momento' | translate }}</button>
      </div>

    </div>
  </div>
</div>

<div class="modal fade show modal-dialog-delete" tabindex="-1"  *ngIf="message && message?.type=='delete_sub'" role="dialog" style="display:block!important" >
  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-body" >
        <h4 class="text-center font-size-24">{{message.text}}</h4>
        <p class="text-center mb-5">{{ 'La eliminación no puede revertirse, tendrás que recrear la subactividad y se podrían generar inconsistencias en la información, haremos lo posible para evitarlo' | translate }}</p>
        <button type="button" class="btn btn-primary btn-no d-block mb-2"  (click)="message.noFn()">{{ 'No, no eliminar' | translate }}</button>
        <button type="button" class="btn btn-link btn-yes m-auto d-block" (click)="message.yesFn()">{{ 'Sí, deseo eliminar la subactividad' | translate }}</button>
      </div>

    </div>
  </div>
</div>

<div class="modal fade show modal-dialog-delete" tabindex="-1"  *ngIf="message && message?.type=='delete_causal'" role="dialog" style="display:block!important" >
  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-body" >
        <h4 class="text-center font-size-24">{{message.text}}</h4>
        <p class="text-center mb-5">{{ 'La eliminación no puede revertirse, tendrás que recrear la causal y se podrían generar inconsistencias en la información, haremos lo posible para evitarlo' | translate }}</p>
        <button type="button" class="btn btn-primary btn-no d-block mb-2"  (click)="message.noFn()">{{ 'No, no eliminar' | translate }}</button>
        <button type="button" class="btn btn-link btn-yes m-auto d-block" (click)="message.yesFn()">{{ 'Sí, deseo eliminar la causal' | translate }}</button>
      </div>

    </div>
  </div>
</div>

<div class="modal fade show modal-dialog-delete" tabindex="-1"  *ngIf="message && message?.type=='delete_assig'" role="dialog" style="display:block!important" >
  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-body" >
        <h4 class="text-center font-size-24">{{message.text}}</h4>
        <p class="text-center mb-5">{{ 'La eliminación no puede revertirse, tendrás que recrear la asignación y se podrían generar inconsistencias en la información, haremos lo posible para evitarlo' | translate }}</p>
        <button type="button" class="btn btn-primary btn-no d-block mb-2"  (click)="message.noFn()">{{ 'No, no eliminar' | translate }}</button>
        <button type="button" class="btn btn-link btn-yes m-auto d-block" (click)="message.yesFn()">{{ 'Sí, deseo eliminar la asignación' | translate }}</button>
      </div>

    </div>
  </div>
</div>

<div class="modal fade show modal-dialog-delete" tabindex="-1"  *ngIf="message && message?.type=='deactivate'" role="dialog" style="display:block!important" >
  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-body" >
        <h4 class="text-center font-size-24">{{message.text}}</h4>
        <p class="text-center mb-5">{{ 'Podrás activarlo cuando quieras' | translate }}</p>
        <button type="button" class="btn btn-primary btn-no d-block mb-2"  (click)="message.noFn()">{{ 'No, no quiero inactivar todos los ítems' | translate }}</button>
        <button type="button" class="btn btn-link btn-yes m-auto d-block" (click)="message.yesFn()">{{ 'Sí, quiero inactivar todos los ítems' | translate }}</button>
      </div>

    </div>
  </div>
</div>

<div class="modal fade show modal-dialog-delete" tabindex="-1"  *ngIf="message && message?.type=='deactivate_item'" role="dialog" style="display:block!important" >
  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-body" >
        <h4 class="text-center font-size-24">{{message.text}}</h4>
        <p class="text-center mb-5">{{ 'Podrás activarlo cuando quieras' | translate }}</p>
        <button type="button" class="btn btn-primary btn-no d-block mb-2"  (click)="message.noFn()">{{ 'No, no quiero inactivar este ítem' | translate }}</button>
        <button type="button" class="btn btn-link btn-yes m-auto d-block" (click)="message.yesFn()">{{ 'Sí, quiero inactivar este ítem' | translate }}</button>
      </div>

    </div>
  </div>
</div>

<div class="modal fade show modal-dialog-delete" tabindex="-1"  *ngIf="message && message?.type=='deactivate_page'" role="dialog" style="display:block!important" >
  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-body" >
        <h4 class="text-center font-size-24">{{message.text}}</h4>
        <p class="text-center mb-5">{{ 'Al momento de activar los ítems deberás hacerlo de manera individual' | translate }}</p>
        <button type="button" class="btn btn-primary btn-no d-block mb-2"  (click)="message.noFn()">{{ 'No, no quiero inactivar todos los ítems' | translate }}</button>
        <button type="button" class="btn btn-link btn-yes m-auto d-block" (click)="message.yesFn()">{{ 'Sí, quiero inactivar todos los ítems' | translate }}</button>
      </div>

    </div>
  </div>
</div>


<div class="modal fade show" tabindex="-1"  *ngIf="message && message?.type=='info'" role="dialog" style="display:block!important" >
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ 'Informacion' | translate }}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="message.noFn()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" *ngIf="message?.type == 'info'" >
        <p>{{message.text}}</p>
      </div>
      <div class="modal-footer" *ngIf="!message.edit">
        <button type="button" class="btn btn-primary"  (click)="message.yesFn()">{{ 'OK' | translate }}</button>
      </div>
    </div>
  </div>
</div>
